<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>项目编号：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.projectNum"
        ></Input>
      </div>
      <div class="search">
        <span>项目简编：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.projectNumShort"
        ></Input>
      </div>
      <div class="search">
        <span>单位名称：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.orderCompany"
        ></Input>
      </div>
      <div class="search">
        <span>状态：</span>
        <Select
          style="width:80px;"
          v-model="searchValue.orderStatus"
        >
          <Option
            v-for="item in statusList"
            :value="item.value"
            :key="item.value"
          >{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input
          v-model="searchValue.amount[0]"
          style="width:80px;margin-right:5px;"
        ></Input>
        <span> - </span>
        <Input
          v-model="searchValue.amount[1]"
          style="width:80px;margin-right:5px;"
        ></Input>
      </div>
      <div class="search">
        <span>收/退款时间：</span>
        <DatePicker
          v-model="searchValue.payTime"
          type="daterange"
          placement="bottom-end"
          style="width: 150px;margin-right:5px"
        ></DatePicker>
      </div>
      <div class="search">
        <span>支付方式：</span>
        <Input
          v-model="searchValue.payType"
          style="width:120px"
        ></Input>
      </div>
      <div class="search">
        <span>订单类型：</span>
        <Select
          disabled
          style="width:100px;"
          v-model="searchValue.orderType"
        >
          <Option
            v-for="item in typeList"
            :value="item.value"
            :key="item.value"
          >{{ item.label }}</Option>
        </Select>
      </div>
      <Button
        type="primary"
        icon="ios-search"
        style="margin: 0 10px 0 10px;"
        @click="searchOrder"
      >搜索</Button>
    </div>
    <Table
      :columns="ordersColumns"
      :data="ordersList"
      style="min-width:1200px;"
    ></Table>
    <Page
      ref="page"
      :current="currentPage"
      style="margin-top:10px;"
      :total="totalOrders"
      show-elevator
      show-total
      @on-change="changePage"
    ></Page>
    <Modal v-model="serviceVisible" title="服务费收取情况" width="800">
      <Table :columns="serviceColumns" :data="serviceList"></Table>
    </Modal>
  </div>
</template>

<script>
import ajax from '../../lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { formatDate } from '@/lib/tool'

export default {
  name: 'depositDetail',
  data() {
    return {
      ordersList: [],
      ordersColumns: [
        {
          title: '单位',
          key: 'ghfCompanyName'
        },
        {
          title: '项目编号',
          width: 180,
          key: 'projectFull'
        },
        {
          title: '包组',
          width: 60,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '应收保证金',
          width: 100,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.marginAmount)
          }
        },
        {
          title: '收/退金额',
          key: 'orderAmountTotal',
          width: 90
        },
        {
          title: '订单类型',
          key: 'orderType',
          width: 90,
          render: (h,params) => {
            return params.row.orderType == '保证金' ? h('div','收保证金') : h('div',params.row.orderType)
          }
        },
        {
          title: '状态',
          width: 60,
          render: (h, params) => {
            let status = '/'
            let statusColor = '#000'
            switch (params.row.orderStatus) {
              case '0':
                status = '退保'
                statusColor = '#2d8cf0'
                break
              case '2':
                status = '未退'
                statusColor = '#ff9900'
                break
              case '4':
                status = '已退'
                statusColor = '#19be6b'
                break
            }
            return h('div', {
              style: {
                color: statusColor
              }
            }, status)
          }
        },
        {
          title: '收/退时间',
          width: 100,
          render: (h, params) => {
            let time = ''
            if (!!params.row.payTime) {
              time = params.row.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '支付方式',
          width: 90,
          render: (h, params) => {
            let payChannel = '无'
            if (!!params.row.payChannel) {
              payChannel = params.row.payChannel
            }
            return h('div', payChannel)
          }
        },
        {
          title: '确认人',
          key: 'confirm',
          width: 75
        },
        {
          title: '操作',
          width: 150,
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  // 服务费查询
                  this.getService(params.row.projectId, params.row.ghfCompanyName)
                }
              }
            }, '服务费情况')
          }
        }
      ],
      currentPage: 1,
      totalOrders: 0,
      searchValue: {
        orderCompany: '',
        orderStatus: '',
        orderType: '保证金',
        payType: '',
        projectNum: '',
        projectNumShort: '',
        amount: ['', ''],
        payTime: []
      },
      statusList: [
        {
          value: '0',
          label: '退保'
        },
        {
          value: '2',
          label: '未退'
        },
        {
          value: '4',
          label: '已退'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      typeList: [
        {
          value: '报名',
          label: '报名'
        },
        {
          value: '保证金',
          label: '保证金'
        },
        {
          value: '服务费',
          label: '服务费'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      serviceVisible: false,
      serviceList: [],
      serviceColumns: [
        {
          title: '单位名称',
          key: 'companyName'
        },
        {
          title: '项目编号',
          key: 'projectFull'
        },
        {
          title: '服务费',
          key: 'amount',
          width: 80
        },
        {
          title: '收取时间',
          width: 100,
          render: (h, params) => {
            let time = '无'
            if (params.row.ordersDto) {
              time = params.row.ordersDto.payTime.split('T')[0]
            }
            return h('div', time)
          }
        }
      ]
    }
  },
  created() {
    this.getOrders(1, this.searchValue)
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'depositDetail') {
        this.getOrders(this.currentPage, this.searchValue)
      }
    }
  },
  methods: {
    async getOrders(page, { orderId, orderCompany, orderStatus, orderType, feeType, payType, projectNum, projectNumShort, payTime, amount }) {
      this.currentPage = page
      let dbSearOrderId = !orderId ? '' : ` and orderNo.Contains("${orderId}")`
      let dbSearOrderCompany = !orderCompany ? '' : ` and ghfCompanyName.Contains("${orderCompany}")`
      let dbSearOrderStatus = !orderStatus ? '' : ` and orderStatus == "${orderStatus}"`
      let dbSearOrderType = !orderType ? '' : ` and orderType.contains("${orderType}")`
      let dbSearFeeType = !feeType ? '' : ` and debitAndCredit == "${feeType}"`
      let dbSearPayType = !payType ? '' : ` and payChannel.contains("${payType}")`
      let dbSearProjectNum = !projectNum ? '' : ` and clProjectDb.projectFull.contains("${projectNum}")`
      let dbSearProjectNumShort = !projectNumShort ? '' : ` and clProjectDb.projectShort.contains("${projectNumShort}")`
      let amountLowerSear = (amount[0] || parseInt(amount[0]) === 0) ? ` and orderAmountTotal >= "${amount[0]}"` : ''
      let amountUpperSear = (amount[1] || parseInt(amount[1]) === 0) ? ` and orderAmountTotal <= "${amount[1]}"` : ''
      let start = ''
      let end = ''
      if (payTime[0] && payTime[1]) {
        start = formatDate(payTime[0]).split(' ')[0]
        end = formatDate(payTime[1]).split(' ')[0]
      }
      let dbSearPayTime = (start && end) ? ` and payTime >= "${start}" and payTime <= "${end}"` : ''

      let filterData = dbSearOrderId + dbSearOrderCompany + dbSearOrderStatus + dbSearOrderType + dbSearFeeType + dbSearPayType + dbSearProjectNum + dbSearPayTime + amountLowerSear + amountUpperSear + dbSearProjectNumShort
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
          filter: filterData.slice(5),
          sorting: 'creationTime desc'
        }
      })
      if (rep.data.success) {
        this.ordersList = rep.data.result.items
        this.totalOrders = rep.data.result.totalCount
      }
    },
    changePage(page) {
      this.getOrders(page, this.searchValue)
    },
    searchOrder() {
      this.getOrders(1, this.searchValue)
    },
    async getService(projectId, companyName) {
      this.$Spin.show()
      let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
        params: {
          filter: `s.projectId == "${projectId}" and s.companyName.contains("${companyName}")`,
          sorting: 's.creationTime desc',
          maxResultCount: 100,
          skipCount: 0
        }
      })
      this.$Spin.hide()
      this.serviceList = []
      if (rep.data.success) {
        this.serviceList = rep.data.result.items
      }
      this.serviceVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
